






























































































































































































































































































































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Accordion from "../../shared/Accordion.vue";
import date from "@/filters/DateFilter";
import datetime from "@/filters/DateTimeFilter";
import { SelectOptionDef } from "@/model/component.model";
import {
  PickupDTO,
  ShipmentDetailsOutputDTO,
  ShipmentRatesDTO,
  ShipmentDTO,
  ZonosCalculateResponseDTO,
  CustomDutyDetailsDTO,
  CustomDutyValueDTO,
  ConfigurationDTO
} from "@/model/data.model";
import "intersection-observer";
import { isItaly, isSpain, isPortugal, isUk } from "@/services/Helpers";
import * as moment from "moment";
import { MBEShipServiceBusiness } from "@/model/enumeration.model";
import { format } from "date-fns";
import { ShipmentService } from "@/services/ShipmentService";
import { TaxDutyService } from "@/services/TaxDutyService";
import {
  LandedCostCategory,
  countsZonosFee,
  landedCostBaseCurrency,
  mapZonosLandedCost
} from "@/utils/zonosLandedCost";
import { getMultiStoreId, getTenantId } from "@/services/AuthService";
import { getKeyValueConfig } from "@/utils/fetchKeyValueConfigLevel";

@Component({
  components: {
    MbeAccordion: Accordion
  }
})
export default class NewShipmentSidebar extends Vue {
  @Prop() shipment: ShipmentDTO;
  @Prop() pickupRequested: boolean;
  @Prop() prices: ShipmentDetailsOutputDTO;
  @Prop() disabledMbePricelist: boolean;
  @Prop() detailsInError: boolean;
  @Prop() edition: boolean;
  @Prop() detailsCalled: boolean;
  @Prop() pickupOptionVisible: boolean;
  @Prop() disableAttachmentPaperlessDocumentFlag: boolean;
  @Prop({ default: false }) paperlessPostClosure: boolean;
  @Prop({ default: false }) courierPickupEmpty: boolean;
  @Prop({ default: false }) isWineShipment: boolean;
  @Prop({ default: false }) disableAttachments: boolean;
  @Prop({ default: false }) wineProductUS: boolean;

  isETAMolEnabled = false;
  fixSidebar = false;
  modalAttachmentsEnabled: boolean;

  estimatedTimes: any = [];
  showEstimatedTimes = false;

  get hidePricesBySource() {
    const currentSource =
      this.prices?.priceSource || this.shipment?.priceSource;
    if (
      (currentSource === "MBE" && this.disabledMbePricelist) ||
      this.detailsInError ||
      currentSource === "NONE"
    ) {
      //if ((currentSource === "MBE" && this.disabledMbePricelist) || currentSource === "NONE") {

      //if price source MBE disable show prices if shipment is still editable
      return true;
    } else {
      return false;
    }
  }

  get zonosCalculateResponse(): ZonosCalculateResponseDTO | null {
    return this.$store.getters["shipment/zonosCalculateResponse"];
  }

  get customDutyDetails(): CustomDutyDetailsDTO | null {
    if (this.zonosCalculateResponse === null) return null;
    return this.zonosCalculateResponse.amountSubtotal;
  }

  get customDutyDetailsTaxes(): CustomDutyValueDTO | null {
    return this.customDutyDetails ? this.customDutyDetails.taxes : null;
  }

  get customDutyDetailsDuties(): CustomDutyValueDTO | null {
    return this.customDutyDetails ? this.customDutyDetails.duties : null;
  }

  get customDutyDetailsZonosFee(): CustomDutyValueDTO | null {
    return this.customDutyDetails ? this.customDutyDetails.zonosFee : null;
  }

  get customDutyDetailsFees(): CustomDutyValueDTO | null {
    return this.customDutyDetails ? this.customDutyDetails.fees : null;
  }

  // Landed cost amounts are in the currency Zonos reports; the store currency is the fallback (task 4545901706).
  get landedCostCurrency(): string {
    return this.landedCostCurrencyCode || this.$store.getters.currency || "";
  }

  // Full per-line Zonos landed cost breakdown, lazy-loaded when the info tooltip opens (task 4492435474).
  landedCostDetail: LandedCostCategory[] | null = null;
  landedCostCurrencyCode: string | null = null;
  landedCostLoading = false;
  landedCostError = false;
  landedCostLoadedFor: string | null = null;

  async openLandedCostDetail() {
    const id = this.zonosCalculateResponse
      ? this.zonosCalculateResponse.zonosId
      : null;
    if (!id || this.landedCostLoadedFor === id) return;
    const zonosFeeCounted = countsZonosFee(this.customDutyDetails);
    this.landedCostLoading = true;
    this.landedCostError = false;
    try {
      const res = await TaxDutyService.prototype.getZonosLandedCost(id);
      this.landedCostDetail = mapZonosLandedCost(res, zonosFeeCounted);
      this.landedCostCurrencyCode = landedCostBaseCurrency(res) || null;
      this.landedCostLoadedFor = id;
    } catch (e) {
      this.landedCostError = true;
    } finally {
      this.landedCostLoading = false;
    }
  }

  get hidePaperless() {
    return this.$store.getters["customer/config"].disablePaperlessFeature;
  }
  clickedAttachmentsDocument() {
    this.$emit("toggleAttachements", this.modalAttachmentsEnabled);
  }

  @Watch("shipment.mbePickupManual")
  onMbePickupManualChange(status: boolean) {
    if (status) {
      this.shipment.pickupRequested = false;
    }
  }

  @Watch("shipment.pickupRequested")
  onPickupChange(status: boolean) {
    if (status) {
      this.shipment.mbePickupManual = false;
    }
    this.$emit("recalculatePrice");
  }

  get useCustomerAddressAsSender(): boolean {
    return !!this.$store.getters["customer/config"].customerAddressAsSender;
  }

  // task 4430742788 (3PP): a courier pickup forces the flag on (and locks the checkbox).
  get thirdPartyForced(): boolean {
    return !!(this.shipment && this.shipment.pickupRequested);
  }

  get thirdPartyDisabled(): boolean {
    return this.thirdPartyForced || !this.edition;
  }

  // task 4430742788 (3PP): toggling recalculates the price so the BE can add/remove the 106 surcharge.
  clickedThirdParty() {
    this.shipment.thirdParty = !this.shipment.thirdParty;
    this.$emit("recalculatePrice");
  }

  get isInboundShipment() {
    return (
      this.$route.query.type === "inbound" &&
      this.$store.getters.features.inbound
    );
  }

  get optionsIsDisabled() {
    return (
      (this.isInboundShipment && this.shipment.status === "DRAFT_NO_WAYBILL") ||
      (this.isInboundShipment && this.shipment.status === "DRAFT_WAYBILL") ||
      (this.isInboundShipment && this.shipment.status === "CREATED") ||
      (this.isInboundShipment && this.shipment.delivered == true) ||
      !this.edition
    );
  }

  get extraServices(): any[] {
    if (
      ["DRAFT_TO_BE_CLOSED", "DRAFT_NO_WAYBILL", "DRAFT_WAYBILL"].includes(
        this.shipment.status
      )
    ) {
      if (this.prices && this.prices.surcharges) {
        return this.prices.surcharges.filter((s: any) => {
          return (
            s.price &&
            this.shipment.dismissedExtraServices.filter(
              d => d.mbeBusinessId === s.mbeBusinessId
            ).length === 0
          );
        });
      }
      return [];
    } else {
      return this.shipment.extraServices.filter(value => value.price);
    }
  }
  get showAttachment() {
    if (this.disableAttachments) return false;
    if (!this.detailsCalled && !this.shipment.shipmentId) {
      return false;
    }
    return !(
      this.showPaperlessCheckbox &&
      !this.disableAttachmentPaperlessDocumentFlag &&
      !this.hidePaperless
    );
  }
  get canSelectCourier() {
    return this.$store.getters["customer/config"].canSelectCourier;
  }

  get etaFallbackActive() {
    return this.$store.getters["customer/config"].etaFallbackActive || false;
  }

  async initETAMOLStatus() {
    const obj = {
      tenantId: getTenantId(),
      multistoreId: null,
      storeId: null,
      confKey: "SYS_ACTIVATION_MOL_ETA"
    } as ConfigurationDTO;

    const response = await ShipmentService.prototype.getStoreKeys([obj]);
    this.isETAMolEnabled = getKeyValueConfig(
      response,
      "SYS_ACTIVATION_MOL_ETA"
    );
  }

  async created() {
    this.modalAttachmentsEnabled = this.shipment.hasAttachment;
    this.clickedAttachmentsDocument();
    await this.initETAMOLStatus();
  }

  @Watch("showEstimatedTimes")
  onShowEstimatedTimesChange() {
    if (this.showEstimatedTimes) {
      this.estimatedTimes = [];
      const data: ShipmentRatesDTO = {
        shipments: [],
        localStrategyActive: this.etaFallbackActive
      };
      const shipmentObjectToSend = {
        ...this.shipment,
        tenantId: getTenantId(),
        multiStoreId: getMultiStoreId(),
        preferredPickupDate: this.shipment.pickup.pickupDate,
        shipmentSource: this.shipment.shipmentSource || "MBE_ONLINE"
      };
      delete shipmentObjectToSend.alternativeAddress;

      if (this.shipment.courierId || this.shipment.mbeServiceId) {
        data.shipments.push({
          first: 1,
          second: shipmentObjectToSend
        });
      } else {
        const visibleMBEServices = this.$store.getters[
          "shipment/visibleMBEServices"
        ].map((service: any) => {
          return {
            id: service.idMBEService,
            name: service.mbeServiceName
          };
        });

        visibleMBEServices.forEach((mbeService, index) => {
          data.shipments.push({
            first: index + 1,
            second: {
              ...shipmentObjectToSend,
              courierServiceId: null,
              courierServiceName: null,
              courierId: null,
              courierName: null,
              mbeService: mbeService.name,
              mbeServiceId: mbeService.id
            }
          });
        });
      }

      ShipmentService.getShipmentRates(data)
        .then(res => {
          res.forEach(item => {
            if (
              item.rateShipmentInfoDtoList &&
              item.rateShipmentInfoDtoList.length > 0
            ) {
              this.estimatedTimes.push(...item.rateShipmentInfoDtoList);
            }
          });
        })
        .catch(err => {});
    }
  }

  getPayload() {
    const customerMbeId = this.$store.getters["customer/customerMbeId"];
    const packs = [];
    this.shipment.shipmentPackages.forEach((item, i) => {
      const pack = {
        courierWeight: item.courierWeight,
        customerWeight: item.customerWeight,
        depth: item.depth,
        height: item.height,
        sequence: item.sequence,
        width: item.width
      };
      packs.push(pack);
    });
    return {
      shipType: this.shipment.shipmentType || "EXPORT",
      zipCodeFrom: this.shipment.addressFrom.zipCode,
      placeNameFrom: this.shipment.addressFrom.city || "",
      zipCodeTo: this.shipment.addressTo.zipCode,
      placeNameTo: this.shipment.addressTo.city || "",
      idMBECustomer: customerMbeId,
      idSubcountryFrom: this.shipment.addressFrom.subcountryId,
      idSubcountryTo: this.shipment.addressTo.subcountryId,
      idMBEService: this.shipment.mbeServiceId || null,
      idMBEPackType: this.shipment.shipPackTypeId,
      pickupDate: moment(this.shipment.pickup.pickupDate).format("DD/MM/YYYY"),
      skipRate: true,
      useOtherExtraServiceAndShipmentAndExtraServiceValueForBase: false,
      packageNumber: this.shipment.shipmentPackages.length,
      packages: packs,
      inputSurcharges: this.getSurcharges()
    };
  }

  getSurcharges() {
    if (!this.shipment.extraServices) return [];
    return this.shipment.extraServices.map(item => ({
      mbeBusinessId: item.mbeBusinessId,
      extraServiceValue: item.extraServiceValue
    }));
  }

  deliveryDate(row: any) {
    const { estimatedDeliveryDate, rateTimeVisible } = row;

    let displayedDeliveryDate = "N/A";
    if (estimatedDeliveryDate) {
      const shouldAddMissingMiliseconds =
        String(estimatedDeliveryDate).length < 13;
      //adding missing milliseconds (* 1000) for new Date()
      const milisecondsMultiplier = shouldAddMissingMiliseconds ? 1000 : 1;
      const newDate = String(
        new Date(parseInt(estimatedDeliveryDate) * milisecondsMultiplier)
      );
      displayedDeliveryDate = rateTimeVisible
        ? datetime(newDate)
        : date(newDate);
    }
    return displayedDeliveryDate;
  }

  @Watch("shipment", { deep: true })
  closeEstimatedTimes() {
    this.estimatedTimes = [];
    this.showEstimatedTimes = false;
  }

  shouldDisplayDeliveryDateTilde(row: any) {
    return this.deliveryDate(row) !== "N/A" && row.rateFromWebService === false;
  }

  get shouldDisplayDeliveryDateColumn() {
    return this.$store.getters["customer/config"].showTransitTime;
  }

  toggleShipmentTemplate(isDisabled) {
    if (!isDisabled) {
      this.shipment.saveShipmentTemplate = !this.shipment.saveShipmentTemplate;
      return true;
    }
    return false;
  }

  formatDecimal(value) {
    value = value.toFixed(2);
    if (isItaly()) {
      return String(value).replace(".", ",");
    }
    return value;
  }

  stepEnterHandler(element: any) {
    if (element.direction === "down") {
      this.fixSidebar = true;
    } else {
      this.fixSidebar = false;
    }
  }

  clickedPickupRequest(isDisabled) {
    if (!isDisabled) {
      this.shipment.pickup = new PickupDTO();
      if (
        this.shipment.mbeServiceId ===
          MBEShipServiceBusiness.GEL_PROXIMITY_POINT ||
        this.shipment.mbeServiceId === MBEShipServiceBusiness.MBE_ACCESS_POINT
      ) {
        const date = new Date();
        const day = date.getDay();
        const daysToAdd = day === 5 ? 3 : 1;
        date.setDate(date.getDate() + daysToAdd);
        const pickupDate = format(date, "yyyy-MM-dd");
        this.shipment.pickup.pickupDate = pickupDate;
        this.shipment.pickup.preferredFrom = "09:00";
        this.shipment.pickup.preferredTo = "18:00";
        this.shipment.pickup.alternativeTo = "09:00";
        this.shipment.pickup.alternativeFrom = "18:00";
      }
      this.shipment.pickupRequested = !this.shipment.pickupRequested;
    }
  }

  get paperlessCheckboxEditable(): boolean {
    return this.edition || this.paperlessPostClosure;
  }

  clickedSentPaperlessDocument(isDisabled) {
    if (!isDisabled) {
      this.shipment.sentPaperlessDocument = !this.shipment
        .sentPaperlessDocument;
      if (this.edition) this.$emit("recalculatePrice");
    }
  }

  get showSettingsAccordion() {
    return (
      this.$store.getters["customer/config"]
        .enableSaveDefaultShipmentSettings ||
      this.$store.getters["customer/config"].pickupEnabled ||
      this.$store.getters.features.storePaperlessEnabled
    );
  }

  get showPaperlessCheckbox() {
    if (this.wineProductUS) return false;
    if (
      this.$store.getters.features.storePaperlessEnabled &&
      this.detailsCalled
    ) {
      return true;
    }
    return (
      this.$store.getters.features.storePaperlessEnabled &&
      this.$route.name === "EditShipment"
    );
  }

  get uk() {
    return isUk();
  }

  get idsNoDistance() {
    return this.shipment.courierId === 14 && !this.shipment.distanceFromTo;
  }
}
